import React, { useEffect } from "react";
import { useVesselPositions } from "./hooks/useVesselPossitions";
import { useChatMessages } from "./hooks/useChatMessages";
import { useAppContext } from "./contexts/AppContext";
import { useChatContext } from "./contexts/ChatContext";

const AppInitializer: React.FC = () => {
  const { getPositionsQueued } = useVesselPositions();
  const { getMessagesQueued } = useChatMessages();
  const { setLoading } = useAppContext();
  const { lastMessageDataTime } = useChatContext();
  const lastMessageDataTimeRef = React.useRef<number>(lastMessageDataTime);
  useEffect(() => {
    lastMessageDataTimeRef.current = lastMessageDataTime;
  }, [lastMessageDataTime]);

  useEffect(() => {
    async function init() {
      setLoading(true);
      await Promise.all([
        getPositionsQueued(),
        getMessagesQueued(),
      ]);
      setLoading(false);
    }
    init();

    const posInterval = setInterval(() => getPositionsQueued(), 120000);
    const msgInterval = setInterval(() => getMessagesQueued(), 120000);

    return () => {
      clearInterval(posInterval);
      clearInterval(msgInterval);
    };
  }, []);

  return null;
};

export default AppInitializer;
